var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marketing_view"},[_c('div',{staticClass:"fz14"},[_vm._v(" 更懂你的营销体系，始终以营销队伍为中心，聚焦市场趋势与客户需求，真正为团队赋予价值。尊崇自主经营，扁平化事务所架构，尽显精英化协同作战势能。 ")]),_c('div',[_c('img',{attrs:{"src":require("../assets/images/picture_52.png"),"alt":""}})])])
}]

export { render, staticRenderFns }